import React from 'react';

import ArticleCard from "../postCard/ArticleCard";
export default function Posts({posts, loading}) {

    if(loading) {
        return <h2>Loading</h2>
    }
        return (
            <>
             <ul className="list-group d-flex flex-column align-items-center justify-content-center  mb-4 ml-2 mr-2">
                 {posts.map(post => (
                     <React.Fragment>
                        <ArticleCard
                            categories = {post.categories.splice(0,3)}
                            imageUrl = {post.thumbnail}
                            title = {post.title}
                            description = {post.content.substring(0,100)}
                            link = {post.link}
                        />
                         <div className="row mt-3">
                         </div>
                     </React.Fragment>
                 ))}
             </ul>
            </>
        );

}
